import React, { useEffect, useState } from "react";
import "./PaymentDetails.css";

const mockData = {
  tour_title: "7-Day Italian Odyssey",
  flight_count: 4,
  hotel_count: 3,
  activity_count: 10,
  transfer_count: 4,
  visa_included: false,
  start_date: "2025-06-15T10:00:00Z",
  end_date: "2025-06-22T10:00:00Z",
  duration_days: 7,
  duration_nights: 6,
  source_city: "",
  source_country: "India",
  total_adults: 2,
  total_children: 2,
  fare_breakup: {
    currency: "INR",
    total_basic_cost: 307760,
    total_travelers: 4,
    coupon_discount: 0,
    coupon_code: "",
    tds_amount: 3323.81,
    gst_amount: 5982.85,
    grand_total: 382237.92
  }
};

const PaymentDetails = ({ userTour = "user_tour", tourId = "tour_id", baseurl = "http://localhost:8081" }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      try {
        const response = await fetch(
          `${baseurl}/api/${userTour}/${tourId}/cart/overview`
        );
        if (!response.ok) throw new Error("Network error");
        const result = await response.json();
        setData(result);
      } catch (error) {
        setData(mockData);
      }
    };
    fetchPaymentDetails();
  }, [userTour, tourId, baseurl]);

  if (!data) return <div>Loading...</div>;

  const { fare_breakup } = data;

  return (
    <div className="payment-details-container">
      <div className="payment-details-title">Payment Details</div>
      <div className="payment-main-row">
        <div className="payment-info">
          <div className="column1">
            <div className="section">
              <div className="section-title">Fare Breakup</div>
              <div className="fare-detail">
                <div>Total Basic Cost</div>
                <div>
                  <div className="value">
                    {fare_breakup.currency} {fare_breakup.total_basic_cost.toLocaleString()}
                  </div>
                </div>
              </div>
              <div className="traveler-cost">
                {fare_breakup.total_basic_cost && fare_breakup.total_travelers
                  ? `${fare_breakup.currency} ${(fare_breakup.total_basic_cost / fare_breakup.total_travelers).toLocaleString()} x ${fare_breakup.total_travelers} Travellers`
                  : ""}
              </div>
            </div>

            <div className="section">
              <h2 className="section-title">Payment Type</h2>
              <div className="payment-type">
                <div>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #000000",
                      borderRadius: "50%",
                      width: "12px",
                      height: "12px",
                      marginRight: "5px"
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#321e5d",
                        borderRadius: "50%",
                        width: "8px",
                        height: "8px"
                      }}
                    ></span>
                  </span>
                </div>
                <div>Paid Full Amount</div>
              </div>
            </div>
          </div>

          <div className="column2">
            <div>
              <div className="section">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flex: "1"
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className="section-title">Coupon Discount</div>
                    <div className="fare-detail">
                      <span className="bd-coupon-code">
                        {fare_breakup.coupon_code || "-"}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div className="value">
                      -{fare_breakup.currency}{" "}
                      {fare_breakup.coupon_discount
                        ? fare_breakup.coupon_discount.toLocaleString()
                        : "0"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="section">
                <div className="fee-detail">
                  <div style={{ fontWeight: "600" }}>Fees and Taxes</div>
                  <div className="value">
                    {fare_breakup.currency}{" "}
                    {fare_breakup.tds_amount
                      ? fare_breakup.tds_amount.toLocaleString()
                      : "0"}
                  </div>
                </div>
                <div className="fee-detail">
                  <div>GST&nbsp;</div>
                  <div>&nbsp;5.0%</div>
                  <div className="value">
                    {fare_breakup.currency}{" "}
                    {fare_breakup.gst_amount
                      ? fare_breakup.gst_amount.toLocaleString()
                      : "0"}
                  </div>
                </div>
                <div className="fee-detail">
                  <div>TCS&nbsp;</div>
                  <div>5.0%</div>
                  <div className="value">
                    {fare_breakup.currency}{" "}
                    {fare_breakup.tds_amount
                      ? fare_breakup.tds_amount.toLocaleString()
                      : "0"}
                  </div>
                </div>
              </div>
            </div>

            <div className="section">
              <h2 className="section-title">Payment Mode</h2>
              <div className="payment-mode">
                Paid {fare_breakup.currency} {fare_breakup.grand_total.toLocaleString()} through Bank Transfer
              </div>
            </div>
          </div>
          <div className="total-amount-paid">
            <div className="total-paid-title">TOTAL AMOUNT PAID</div>
            <div className="final-amount">
              {fare_breakup.currency} {fare_breakup.grand_total.toLocaleString()}
            </div>
            <div className="inclusive"> (Inclusive of GST) </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;
